export class MergeNotFoundError extends Error {
  constructor() {
    super('merge not found')
  }
}
